/* ============
 * Loading Component
 * ============
 */


export default {
  props: {
    isLoading: {
      type: Boolean,
      required: true
    },
    isHeightAuto: {
      type: Boolean,
      required: false
    },
    color: {
      default: '#D7092E',
      type: [String],
    },
    height: {
      default: '75',
      type: [String, Number],
    },
    width: {
      default: '75',
      type: [String, Number],
    },
    viewbox: {
      default: '0 0 75 75',
      type: [String, Number],
    },
    cx: {
      default: '37.5',
      type: [String, Number],
    },
    cy: {
      default: '37.5',
      type: [String, Number],
    },
    r: {
      default: '33.5',
      type: [String, Number],
    }
  },
  computed: {
    // classNames() {
    //   const classNames = ['page'];
    //
    //   if (this.contextualStyle) {
    //     classNames.push(`panel-${this.contextualStyle}`);
    //   } else {
    //     classNames.push('panel-default');
    //   }
    //
    //   return classNames;
    // },
  },
};



// WEBPACK FOOTER //
// ./src/app/components/loading/loading.js